<template>
    <b-row>
        <b-col md="3">
            <b-form-input v-model="searchFilter" :placeholder="$t('recherche_label')" size="sm"></b-form-input>
        </b-col>
        <b-col md="3">
            <b-form-select v-model="courseFilter" :options="participants.list_courses" @input="onCourseFilterChange"
                size="sm"></b-form-select>
        </b-col>
        <b-col md="2" style="text-align: left">
            <b-button-group>
                <b-button size="sm" class="sex_select_button" v-on:click="setSexeFilter('')"
                    v-bind:class="{ sex_selected_button: sexeFilter === '' }">
                    <v-icon name="male" />
                    <v-icon name="female" />
                </b-button>
                <b-button size="sm" class="sex_select_button" v-on:click="setSexeFilter('M')"
                    v-bind:class="{ sex_selected_button: sexeFilter === 'M' }">
                    <v-icon name="male" />
                </b-button>
                <b-button size="sm" class="sex_select_button" v-on:click="setSexeFilter('F')"
                    v-bind:class="{ sex_selected_button: sexeFilter === 'F' }">
                    <v-icon name="female" />
                </b-button>
            </b-button-group>
        </b-col>
        <b-col md="4">
            <b-pagination v-model="page" :total-rows="participants.nb_inscriptions" :per-page="perPage"
                aria-controls="table_participants"></b-pagination>
        </b-col>
    </b-row>
</template>

<script>
export default {
    computed: {
        searchFilter: {
            get() {
                return this.$store.getters["listCoureurs/searchFilter"];
            },
            set(value) {
                this.$store.commit("listCoureurs/setSearchFilter", value);
            }
        },
        courseFilter: {
            get() {
                return this.$store.getters["listCoureurs/courseFilter"];
            },
            set(value) {
                this.$store.commit("listCoureurs/setCourseFilter", value);
            }
        },
        sexeFilter() {
            return this.$store.getters["listCoureurs/sexeFilter"];
        },
        page: {
            get() {
                return this.$store.getters["listCoureurs/page"];
            },
            set(value) {
                this.$store.commit("listCoureurs/setPage", value);
            }
        },
        perPage() {
            return this.$store.getters["listCoureurs/perPage"];
        },
        participants() {
            return this.$store.getters["listCoureurs/participants"];
        }
    },
    watch: {
        searchFilter() {
            const isAdmin = this.$store.getters["authAdmin/hasAdminRights"];
            if (isAdmin) {
                // Si admin : filtre le tableau mais ne remplit pas searched_participants
                this.$store.commit("listCoureurs/resetSearchedParticipants");
                this.$store.commit("listCoureurs/setPage", 1);
                this.$store.dispatch("listCoureurs/fetchInscriptions");
            } else {
                // Si pas admin : remplit searched_participants mais ne filtre pas le tableau
                this.$store.dispatch("listCoureurs/searchInscriptions");
            }
        },
        courseFilter() {
            this.$store.commit("listCoureurs/setPage", 1);
            this.$store.dispatch("listCoureurs/fetchInscriptions");
        },
        sexeFilter() {
            this.$store.commit("listCoureurs/setPage", 1);
            this.$store.dispatch("listCoureurs/fetchInscriptions");
        },
        page() {
            this.$store.dispatch("listCoureurs/fetchInscriptions");
        }
    },
    methods: {
        setSexeFilter(sexe) {
            this.$store.commit("listCoureurs/setSexeFilter", sexe);
        },
        onCourseFilterChange(course) {
            this.$store.commit("listCoureurs/setCourseFilter", course);
            this.$store.state.selected_live_course = course;
        }
    }
}
</script>

<style lang="scss" scoped></style>